export default class CitySwitcher {
    url;

    constructor() {
        if (!window.appData.citySwitcher) {
            console.error('No CitySwitcher config');
            return;
        }

        this.url = window.appData.citySwitcher.url;

        $('.js-city-switcher-trigger').on('click', this.onTriggerClick.bind(this));
    }

    /**
     * @param {MouseEvent} e
     */
    onTriggerClick(e) {
        e.preventDefault();

        let url = this.url;

        let params = new URLSearchParams;

        params.append('backurl', document.location.pathname);

        if (e.target.dataset.citySwitcherMode) {
            params.append('mode', e.target.dataset.citySwitcherMode);
        }

        if (e.target.dataset.citySwitcherCountry) {
            params.append('country', e.target.dataset.citySwitcherCountry);
        }

        url += '?' + params.toString();

        $.fancybox(url, {
            type: 'ajax',
            padding: 0,
            fitToView: false,
            margin: 10,
            afterLoad() {},
            afterShow: () => {
                this.legacyInitAfterLoad();
            }
        });
    }

    legacyInitAfterLoad() {
        $('.city-popup__search-input').on('keyup', this.legacySearch.bind(this));

        $('.city-popup__clear-search').on('click', (e) => {
            e.preventDefault();
            $('.city-popup__search-input').val('').keyup();
        });

        $('.js-city-request-form-link').on('click', (e) => {
            e.preventDefault();

            let form = $(e.target).closest('.js-city-request-form-wrap').find('.js-city-request-form');
            form.show();
        });

        $('.city-tabs__item-js').on('click', this.legacyOnTabClick.bind(this));
    }

    legacySearch(e) {
        const $el = $(e.target);

        const popupWrap = $el.closest('.city-popup__inner-wrap');
        const searchList = popupWrap.find('.citylist__search-result');
        const form = $el.closest('.js-city-request-form-wrap').find('.js-city-request-form');

        searchList.empty();
        let suffix;

        if ($(window).width() > 1279) {
            suffix = 'desktop';
        } else {
            suffix = 'tablet';
        }

        const citylist = popupWrap.find('.citylist__main-wrap');

        const $cities = popupWrap.find('.citylist__main-wrap--' + suffix).find('.citylist__link');
        const result = [];
        const filterValue = $el.val().toLowerCase();

        $cities.each((index, el) => {
            var text = $(el).text().toLowerCase();

            if (text.indexOf(filterValue) !== -1) {
                var toPush = {};
                var country = $(el).closest('.city-tab-wrap').data('country-name');
                if (country) {
                    toPush.country = ' (' + country + ')';
                }
                toPush.element = $(el);

                result.push(toPush);
            }
        });

        if (filterValue !== '') {
            $('.city-popup__clear-search').show();
            citylist.addClass('citylist__main-wrap--hidden');

            if (result.length > 0) {
                result.map(function (it) {
                    let element = it.element.clone();

                    if (it.country) {
                        element.text(element.text() + it.country);
                    }

                    searchList.append($('<li>', { 'class': 'citylist__item' }).addClass('citylist__item--left').append(element));
                });

                form.hide();
            } else {
                let langText = 'Данного города нет в списке. Уточните возможность доставки у менеджера по телефону 8 (800) 777-53-82' +
                    ' или <a class="city-popup__form-link js-city-request-form-link" href="#">оставьте заявку</a>';

                if ($('html').attr('lang') === 'en') {
                    langText = 'City not found, please contact us +7 (499) 110-51-74';
                }

                searchList.append($('<span>').html(langText));
                $('.js-not-ru-search-phrase').hide();
            }

            searchList.show();
        } else {
            $('.city-popup__clear-search').hide();
            $('.js-not-ru-search-phrase').show();
            searchList.hide();
            form.hide();
            citylist.removeClass('citylist__main-wrap--hidden');
        }
    }

    legacyOnTabClick(e) {
        e.preventDefault();

        const $el = $(e.target);
        let $tabInstance = $el.closest('.city-tab-instance');
        let $defaultTab = $tabInstance.find('.city-tabs__item--default');
        let $searchBlock = $tabInstance.find('.city-popup__search-block');
        $tabInstance.find('.js-city-request-form').hide();

        if (!$el.hasClass('city-tabs__item--active')) {
            let tabId = $el.data('tab-id');

            if (tabId) {
                $tabInstance.find('.city-tabs__item.city-tabs__item--active').removeClass('city-tabs__item--active');
                $tabInstance.find('.city-tab-wrap').removeClass('city-tab-wrap--active');
                let tab = $tabInstance.find('.city-tab-wrap--' + tabId);
                tab.addClass('city-tab-wrap--active');

                if (tabId === 'countries') {
                    $searchBlock.hide();
                    $el.addClass('city-tabs__item--active');
                    $defaultTab.removeClass('city-tabs__item--active');
                } else {
                    $defaultTab.data('tab-id', tabId);
                    $defaultTab.addClass('city-tabs__item--active');
                    $searchBlock.show();
                    $defaultTab.text($el.text());
                    $tabInstance.find('.city-popup__all-link').attr('href', tab.data('country-url'));
                }
            }
        }
    }
}